import axios from "./themeInstance"

export default async () => {
  try {
    const response: any = await axios(`/settings`)
    return response.data
  } catch (error) {
    return null
  }
}
